import { SET_FORMS } from '../actions/FormsActions'

const initialState = {}

const FormsReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_FORMS: {
      return {
        ...state,
        ...action.data
      }
    }
    default: {
      return state
    }
  }
}

export default FormsReducer
